import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { useSplitter } from 'utils/useSplitter';
import { ConversationMessages } from './components/messages/conversationMessages';
import { ConversationReply } from './components/reply/conversationReply';
import styles from './conversationMain.module.scss';
/** Represents the main content area of the conversation view. */
export const ConversationMain = () => {
    // NOTE: The value should likely be stored so that it's persistent across
    // conversations and/or sessions.
    const [split, setSplit] = useState(75);
    const { containerStyles, containerRefFn, splitterRefFn } = useSplitter({
        orientation: 'horizontal',
        startPanelMinSize: 200,
        endPanelMinSize: 280,
        splitPosition: split,
        onResizeEnd: setSplit,
    });
    return (_jsxs("div", Object.assign({ ref: containerRefFn, className: styles.root, style: containerStyles }, { children: [_jsx("div", Object.assign({ className: styles.messagesPanel }, { children: _jsx(ConversationMessages, {}) })), _jsxs("div", Object.assign({ className: styles.replyPanel }, { children: [_jsx("div", Object.assign({ ref: splitterRefFn, className: styles.resizeHandle }, { children: _jsx(Icon, { name: "bars" }) })), _jsx(ConversationReply, {})] }))] })));
};
